<template>
  <submit-button
    :submitting="processing"
    label="Proceed to Checkout"
    submitting-label="Processing…"
    classes="-main -large-medium-only no-margin"
    @submit-action="handlePageChange"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import SubmitButton from '@/components/buttons/submit-button.vue'

export default defineComponent({
  name: 'CheckoutButton',
  components: { SubmitButton },
  props: {},
  data() {
    return {
      processing: false,
    }
  },
  methods: {
    async handlePageChange() {
      if (this.processing) {
        return
      }

      // disable
      this.processing = true

      // slight delay to allow for gift email / message saves
      setTimeout(() => {
        window.location.href = '/store/checkout'
      }, 200)
    },
  },
})
</script>
